import React from "react";
import { useSelector } from "react-redux";

export default function SearchErrors() {
  const error01 = useSelector((state) => state.inmates.error01);
  const error02 = useSelector((state) => state.inmates.error02);
  const warning01 = useSelector((state) => state.inmates.warning01);
  const failed = useSelector((state) => state.inmates.failed);
  const error03 = useSelector((state) => state.inmates.error03);

  return (
    <div className="select-none">
      <div
        className="text-red-500 text-lg pb-2 "
        style={{ display: error01 ? "block" : "none" }}
      >
        <span className="underline">ERROR:</span> To request a search, please
        enter either an SCDC ID, First and/or Last name or an SID.
      </div>

      <div
        className="text-red-500 text-lg pb-2 "
        style={{ display: error02 ? "block" : "none" }}
      >
        <span className="underline">ERROR:</span> To request a search, please
        make a selection from the dropdowns provided or select a release date.
      </div>
      <div
        className="text-red-500 text-lg pb-2 "
        style={{ display: error03 ? "block" : "none" }}
      >
        <span className="underline">ERROR:</span> To request a search with a
        release date range, please select a start date and an end date.
      </div>
      <div
        className="text-red-500 text-lg pb-2 "
        style={{ display: warning01 ? "block" : "none" }}
      >
        <span className="underline">WARNING:</span> Your search returned more
        inmates than can be displayed. Search results are limited to 250
        inmates. Please enter more restrictive search criteria and submit your
        search again.
      </div>
      <div
        className="text-red-500 text-lg pb-2 "
        style={{ display: failed ? "block" : "none" }}
      >
        Your search failed to return any results. Please review your search
        criteria and try again.
      </div>
    </div>
  );
}
